import { Injectable } from '@angular/core';
import { IQueryConditionHandler } from './handlers/iquerycondition.handler';
import { QueryConditionHandlerFactory } from './querycondition.handler.factory';
import { QueryCondition } from '../entity/querycondition';



@Injectable()
export class QuerySolutionService {

    constructor() {}


    public setFilterConditions(params: Array<QueryCondition>) {
        let queryConditionHandler: IQueryConditionHandler;
        const filterConditionList = [];
        params.forEach(qc => {
            queryConditionHandler = QueryConditionHandlerFactory.getInstance().getHandler(qc.control.getControlType());
            filterConditionList.push(...queryConditionHandler.convert(qc));
        });
        // 设置到NgCommand params.filter属性上：{UISTATE~/root-component/filterConditionList}
        // this.frameContext.uiState['filterConditionList'] = JSON.stringify(filterConditionList);
        // return JSON.stringify(filterConditionList);
        return filterConditionList;
    }

}
